<template lang="pug">
  v-dialog(v-model="show", persistent, max-width="50%")
      v-card(v-if="indicadores")
          v-card-title.title Incentivos do Bigou
          v-card-text
            div(style="background-color:#FAFAFA; border-radius:8px").mt-4.pl-3.pr-3.mb-4
              v-layout(row,wrap).pt-3.pb-3.mb-3.mt-3
                v-flex.md6.xs12(style="font-size:18px; color:#111312CC")
                  label(style="font-weight:400") Cupons do Bigou
                  br
                  small(style="font-size:16px; color:#1113128A" v-if="indicadores.quantidade_desconto") {{ indicadores.quantidade_desconto | number }} pedidos
                v-flex.md6.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                  strong + {{ indicadores.desconto | currency }}
              v-layout(row,wrap)
                v-flex.md6.xs12(style="font-size:18px; color:#111312CC").pb-3
                  label(style="font-weight:400") Subsídios
                  br
                  small(style="font-size:16px; color:#1113128A" v-if="indicadores.quantidade_reembolso") {{ indicadores.quantidade_reembolso | number }} pedidos
                v-flex.md6.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                  strong + {{ indicadores.reembolso | currency }}
            div(style="border:1px solid; border-radius:8px; color:#0000000A").pt-3.pb-3.mb-3.mt-3.pl-3
              v-layout(row,wrap)
                v-flex.md6.xs12(style="font-size:18px; color:#111312CC")
                  strong Total de Incentivos
                v-flex.md6.xs12.text-md-right.pr-3(style="font-size:18px; color:#000")
                  strong {{ (indicadores.desconto + indicadores.reembolso) | currency }}
          
          v-card-actions.mr-4.pb-3
              v-spacer
              v-btn(flat,@click="close()") Fechar
  
  </template>
    
  <script>
  
  export default {
    props: {
    },
    data () {
      return {
          show : false,
          indicadores : null
      }
    },
    created () {
      
    },
    watch: {
    },
    computed: {
    },
    methods: {
      open(indicadores){
        const vm = this;
        vm.indicadores = indicadores;
        vm.show = true;
      },
      close(){
          const vm = this;
          vm.indicadores = null;
          vm.show = false;
      }
    }
  }
  </script>